import { useQueryClient } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";

export const useRefetchJobs = () => {
  const currentCompanyId = useCurrentCompanyId();
  const queryClient = useQueryClient();

  return () => {
    void queryClient.refetchQueries({
      queryKey: ["jobs", currentCompanyId],
    });
  };
};
